export enum AnnouncementBillingPlanScopeTypeKey {
  ALL = 'all',
  SELECT = 'select'
}
